// tslint:disable: variable-name
import { Imovel } from 'eddydata-lib';
import { BaseResourceModel } from '../../models/base-resource.model';
import { PlanoConta } from '../contabil/plano-conta.model';

export class Terreno extends BaseResourceModel { 
  constructor(
    public id?: number,
    public valor_terreno?: number,
    public descricao?: string,
    public endereco?: string,
    public plano_conta?: PlanoConta,
    public imovel?:Imovel,
  ) {
    super();
  }

  static converteJson(json: any): Terreno {
    return Object.assign(new Terreno(), json);
  }
}
